// API Configuration
// This file centralizes all API endpoint configuration
// It automatically uses the correct URL based on environment

const getBaseUrl = () => {
    if (process.env.REACT_APP_API_URL) return process.env.REACT_APP_API_URL;
    
    // If we're on localhost, default to port 5000 if we're not already on it
    if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
        if (window.location.port === '5000') return '/api/v1';
        return 'http://localhost:5000/api/v1';
    }
    
    // In production, use relative path
    return '/api/v1';
};

const API_BASE_URL = getBaseUrl();
const BASE_URL = API_BASE_URL.replace(/\/api\/v1$/, '');

export const API_URL = API_BASE_URL;
export const UPLOADS_URL = BASE_URL;

// Helper function to get full API endpoint
export const getApiUrl = (endpoint: string): string => {
    // Remove leading slash if present
    const cleanEndpoint = endpoint.startsWith('/') ? endpoint.slice(1) : endpoint;
    return `${API_URL}/${cleanEndpoint}`;
};

// Helper function to get upload/static file URL
export const getUploadUrl = (path: string): string => {
    if (!path) return '';
    // If path already includes http, return as is
    if (path.startsWith('http')) return path;
    // Remove leading slash if present
    const cleanPath = path.startsWith('/') ? path : `/${path}`;
    return `${UPLOADS_URL}${cleanPath}`;
};

export default API_URL;
